/**
 *
 *
 * @export
 * @class ReconnectInProgress
 * @extends {Error}
 */
export default class ReconnectInProgress extends Error {}
